import {
  ListShopQuery,
  ListShopDocument,
  ShopListInput,
} from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 店舗情報を取得する
 * @param shopListInput 店舗情報
 * @returns 店舗情報
 */
export async function getShopList(shopListInput: ShopListInput): Promise<
  | (
      | {
          __typename?: "ShopResponse" | undefined;
          shop_code: string;
          name: string;
        }
      | null
      | undefined
    )[]
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const listShop: ApolloQueryResult<ListShopQuery> =
      await apolloClient.query<ListShopQuery>({
        query: ListShopDocument,
        variables: {
          input: shopListInput,
        },
        fetchPolicy: "no-cache",
      });
    return listShop.data.listShop;
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "店舗情報の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("店舗情報の取得に失敗しました。（Unknown error）");
    }
  }
}
